import React from 'react';
import {List, useRedirect, useTranslate} from 'react-admin';
import {Box, Typography} from '@mui/material';
import {t} from '../themes/statamicTokens';
import StatamicListPage from '../components/statamic/StatamicListPage';
import MonoChip from '../components/statamic/MonoChip';
import {formatDateTime} from '../lib/dates';

const TextCell = ({value}) => (
    <Typography
        sx={{
            fontSize: `${t.type.body.size}px`,
            color: value ? t.color.text.secondary : t.color.text.muted,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }}
    >
        {value ?? '—'}
    </Typography>
);

const UserActionLogsListStatamicInner = () => {
    const redirect = useRedirect();
    const translate = useTranslate();

    const columns = [
        {
            key: 'date', label: translate('Date'), sortable: true, sortField: 'date', width: 170,
            render: (r) => <TextCell value={formatDateTime(r.date)}/>,
        },
        {
            key: 'user', label: translate('User'), width: 120,
            render: (r) => r.nofam_user_id
                ? <MonoChip>#{r.nofam_user_id}</MonoChip>
                : <TextCell value={null}/>,
        },
        {
            key: 'platform', label: 'Platform', width: 110,
            render: (r) => r.platform
                ? <MonoChip>{r.platform}</MonoChip>
                : <TextCell value={null}/>,
        },
        {
            key: 'method', label: 'Method', width: 90,
            render: (r) => r.method
                ? <MonoChip>{r.method}</MonoChip>
                : <TextCell value={null}/>,
        },
        {
            key: 'endpoint', label: 'Endpoint',
            render: (r) => (
                <Typography sx={{fontSize: `${t.type.caption.size}px`, fontFamily: t.font.mono, color: t.color.text.primary, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                    {r.endpoint ?? '—'}
                </Typography>
            ),
        },
        {
            key: 'action', label: 'Action', width: 200,
            render: (r) => <TextCell value={r.action}/>,
        },
    ];

    return (
        <StatamicListPage
            title={translate('User Action Logs')}
            subtitle="API activity by authenticated users"
            columns={columns}
            onRowClick={(record) => redirect('show', 'userActionLogs', record.id)}
        />
    );
};

const UserActionLogsListStatamic = (props) => (
    <List
        {...props}
        sort={{field: 'id', order: 'DESC'}}
        perPage={25}
        actions={false}
        pagination={false}
        component={Box}
        sx={{
            backgroundColor: t.color.page,
            '& .RaList-main': {backgroundColor: t.color.page},
        }}
    >
        <UserActionLogsListStatamicInner/>
    </List>
);

export default UserActionLogsListStatamic;
